import React from "react";
import { useNavigate } from "react-router-dom";
import { Users, FileText, ListChecks, Scale, Cpu, Bot, Plug, Sliders, Bell, History, Shield, GitBranch } from "lucide-react";
import { useI18n } from "../lib/i18n";
import { PageHeader, Card } from "../components/common";

const SETTINGS = [
  { key: "Users & Groups", icon: Users, to: "/users", desc: "Manage users, groups and granular permissions" },
  { key: "Regulatory Codes", icon: Scale, to: "/regulatory", desc: "Configure Qatar regulatory reference codes" },
  { key: "Policies", icon: FileText, to: "/policies", desc: "Manage the AI policy library (EN + AR)" },
  { key: "Controls", icon: ListChecks, to: "/controls", desc: "Manage reusable GRC controls" },
  { key: "Models", icon: Cpu, to: "/models", desc: "Model registry and approval settings" },
  { key: "Agents", icon: Bot, to: "/agents", desc: "Agent registry and guardrails" },
  { key: "Integrations", icon: Plug, to: "/integrations", desc: "Register sandbox-only connectors" },
  { key: "Lifecycle Gates", icon: GitBranch, to: "/lifecycle", desc: "Configure lifecycle stage gates" },
  { key: "Audit Configuration", icon: History, to: "/audit", desc: "Review immutable-style audit trail" },
];

export default function Admin() {
  const { t } = useI18n();
  const nav = useNavigate();
  return (
    <div>
      <PageHeader title={t("nav.admin")} subtitle="Administrator configuration — full sandbox control" summary="System administration. Configure users, groups, regulatory codes, policies, controls, models, agents, integrations and lifecycle gates." />
      <div className="mb-6 rounded-xl border border-[var(--qatar-border)] bg-[var(--qatar-subtle)] p-4 text-sm text-[var(--qatar)]"><Shield className="mb-1 inline h-4 w-4" /> Administrator-only functions. All configuration changes create audit records. No real systems are modified.</div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {SETTINGS.map((s) => {
          const Icon = s.icon;
          return (
            <button key={s.key} data-testid={`admin-${s.key.toLowerCase().replace(/[^a-z]/g, "-")}`} onClick={() => nav(s.to)} className="flex items-start gap-3 rounded-2xl border border-slate-200 bg-white p-5 text-start card-shadow transition-all hover:card-shadow-lg hover:-translate-y-0.5">
              <div className="rounded-xl bg-[var(--qatar-subtle)] p-2.5 text-[var(--qatar)]"><Icon className="h-5 w-5" /></div>
              <div><p className="text-sm font-semibold text-slate-800">{s.key}</p><p className="mt-0.5 text-xs text-slate-500">{s.desc}</p></div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
